import type { ReactNode } from 'react';
import Gtm from '@/components/analytics/GTM';
import { MetaTags } from '@/components/seo';
import styles from '@/layouts/PagesLayout/PagesLayout.module.scss';
import type { PagesLayoutAnalyticsData } from './types';

interface PagesLayoutProps {
  children: ReactNode;
  pageTitle?: string;
  analytics: PagesLayoutAnalyticsData;
}

export function PagesLayout({ children, pageTitle, analytics }: PagesLayoutProps) {
  return (
    <>
      <MetaTags pageTitle={pageTitle} />
      <Gtm gtmId={'GTM-WLLZS6'} isSandbox={analytics.isSandbox} analyticsData={analytics.gtm.data} />
      <div className={styles.spContainer}>{children}</div>
    </>
  );
}
